import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import fileUploadReducer from './slices/fileUploadSlice';
import authReducer from './slices/authSlice';
import offersReducer from './slices/offersSlice';
import profileReducer from './slices/profileSlice';
import cardSetReducer from './slices/cardSetSlice';
import journeyReducer from './slices/journeySlice';
import notificationReducer from './slices/notificationSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'offers', 'profile'], // Persist these reducers
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    offers: offersReducer,
    profile: profileReducer,
    cardSet: cardSetReducer,
    fileUpload: fileUploadReducer,
    journey: journeyReducer,
    notification: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
export default store;
